export default "__VITE_ASSET__Cz7IB6Dx__"